import { Switch } from "@shared/components/DataEntry";

import { useActiveBannerSwitch } from "./controller";
import { ActiveBannerSwitchProps } from "./types";

export function ActiveBannerSwitch(props: ActiveBannerSwitchProps) {
  const { isActive, isPending, toggle } = useActiveBannerSwitch(props);

  return (
    <Switch
      checked={isActive}
      onChange={toggle}
      disabled={isPending}
    />
  );
}
